export default __webpack_public_path__ + "static/media/logonew.34f6dc54.svg";